import { IWebinarParentData } from '@models/interfaces/mock_exam.interface';
import { PAGE_WEBINAR_SELECT } from '@utils/constants/mock-exam.constants';
import { Button } from 'geniebook-ui/dist';
import React from 'react';

const WebinarGetStarted = ({
  setStep,
  parentData,
}: {
  setStep: React.Dispatch<React.SetStateAction<string>>;
  parentData: IWebinarParentData;
}) => {
  return (
    <div className="w-full">
      <p className="text-[24px] leading-[35px] text-primary-navyblue font-black mb-4">
        Register Now
      </p>
      <p className="text-neutral-pencil leading-6 mb-8">
        You are currently logged in as :
      </p>
      <div className="border border-neutral-periwinkle border-solid rounded-2xl h-[108px] mb-6 px-8 flex flex-col justify-center">
        <p className="text-neutral-pencil mb-1 break-words">
          {parentData.name}
        </p>
        <p className="text-neutral-dust text-sm leading-5 break-words">
          {parentData.email}
        </p>
      </div>
      <Button
        variant="primary"
        onClick={() => {
          setStep(PAGE_WEBINAR_SELECT);
        }}
        className="max-w-full"
      >
        Continue
      </Button>
    </div>
  );
};

export default WebinarGetStarted;
